import ReactMarkdown from 'react-markdown';
import { CopyButton } from './CopyButton';

interface VariantCardProps {
  label: string;
  subtitle: string;
  content: string;
}

export function VariantCard({ label, subtitle, content }: VariantCardProps) {
  return (
    <div style={{
      border: '1px solid var(--border)',
      borderRadius: '12px',
      overflow: 'hidden',
      transition: 'all 0.3s ease',
    }}
    onMouseEnter={e => {
      e.currentTarget.style.borderColor = 'rgba(0,212,255,0.25)';
      e.currentTarget.style.boxShadow = '0 8px 30px -8px rgba(0,212,255,0.15)';
    }}
    onMouseLeave={e => {
      e.currentTarget.style.borderColor = 'var(--border)';
      e.currentTarget.style.boxShadow = 'none';
    }}>
      <div style={{
        padding: '12px 16px',
        background: 'var(--bg-elevated)',
        borderBottom: '1px solid var(--border)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <div>
          <p style={{
            fontSize: '13px',
            fontWeight: 600,
            color: 'var(--text-primary)',
            fontFamily: "'Outfit', sans-serif",
            marginBottom: '2px',
            margin: 0,
          }}>{label}</p>
          <p style={{ fontSize: '11px', color: 'var(--text-muted)', margin: 0 }}>{subtitle}</p>
        </div>
        <CopyButton text={content} />
      </div>
      <div style={{
        padding: '16px',
        minHeight: '160px',
        background: 'var(--bg-card)',
      }}>
        <div className="markdown-content">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
